import type { DetailsPanelContentAttachmentsQuery } from '../queries/__types__/DetailsPanelContentAttachmentsQuery';

export const normalizeContentAttachmentsData = (data?: DetailsPanelContentAttachmentsQuery) => ({
	attachmentsCount: data?.singleContent?.attachments?.count ?? 0,
	hasMoreAttachments: data?.singleContent?.attachments?.pageInfo?.hasNextPage ?? false,
});
